import client from './client';

export const getOrderTrackingSummary = () => client.get('/order-tracking/summary');

export const getTrackedOrders = (params) => client.get('/order-tracking/orders', { params });

export const getOrderCallbackLogs = (params) => client.get('/order-tracking/callback-logs', { params });
